import { lang } from "../../assets/lang"

const instagram_addon = window.xitFlowBuilderData.instagram_addon

export const types = [
  { key: 'newPostback', value: lang.quick_reply_html_reply_types_newPostback },
  { key: 'postback', value: lang.quick_reply_html_reply_types_postback },
]

if (! instagram_addon) {
  types.push(
    { key: 'phone', value: lang.quick_reply_html_reply_types_phone }, 
    { key: 'email', value: lang.quick_reply_html_reply_types_email },
  )
}